import { render, staticRenderFns } from "./BoletoEditView.vue?vue&type=template&id=5186ed50&"
import script from "./BoletoEditView.vue?vue&type=script&lang=ts&"
export * from "./BoletoEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports